<template>
  <div>
    <div class="loginDiv">
      <div class="loginTop">
        <img src="../../../static/images/login_logo.png" />
      </div>
      <div class="loginMain">
        <div class="leftDx">
          <img src="../../../static/images/fc_xd.png" class="dx" />
        </div>
        <div class="login">
          <img src="../../../static/images/dz_xd.png" class="dz" />
          <div class="logoL">
            <img src="../../../static/images/loginL.png" />
          </div>
          <el-form :rules="rules" :model="formData" size="small" ref="baseForm">
            <!-- <span class="tip">测试用，随便输入，或直接点击登录</span> -->
            <el-form-item prop="username">
              <el-input v-model.trim="formData.username" placeholder="账户" prefix-icon="el-icon-user"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model.trim="formData.password" placeholder="密码" prefix-icon="el-icon-lock" show-password></el-input>
            </el-form-item>
            <el-form-item prop="checked">
              <el-checkbox v-model="formData.checked">记住密码</el-checkbox>
            </el-form-item>
            <el-form-item class="formBtn">
              <el-button type="primary" :disabled="disable" id="loginBtn" @click="login" :class="{'disable':!disable}">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/datas';
export default {
  data () {
    return {
      disable: true,
      formData: {
        username: "",
        password: "",
        checked: true
      },
      rules: {
        username: [
          { required: true, message: "请输入姓名或手机号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    'formData.username' (newVal, oldVal) {
      this.formData.username = newVal.length > oldVal.length ? newVal.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3') : this.formData.username.trim();
      let password = this.formData.password;
      if (newVal && password != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
    'formData.password' (newVal, oldVal) {
      let username = this.formData.username;
      if (newVal && username != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    }
  },
  mounted () {
    this.account();  //获取cookie的方法
  },
  methods: {
    account () {
      if (document.cookie.length >= 0) {
        //console.log(this.getCookie('username'));
        this.formData.username = this.getCookie('username');
        this.formData.password = this.getCookie('password');
      }
    },
    setCookie (c_name, c_pwd, exdate) {  //账号，密码 ，过期的天数
      var currentDate = new Date();
      //console.log(c_name, c_pwd);
      currentDate.setTime(currentDate.getTime() + 24 * 60 * 60 * 1000 * exdate);  //保存的天数
      document.cookie = "username=" + c_name + ";path=/;expires=" + currentDate.toLocaleString();
      document.cookie = "password=" + c_pwd + ";path=/;expires=" + currentDate.toLocaleString();
    },
    getCookie (name) {
      var arr = document.cookie.split(";");
      //["_ga=GA1.1.1756734561.1561034020", " mobile=123" password=456"]
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');  // ["_ga", "GA1.1.1756734561.1561034020"]
        if (arr2[0].trim() == name) {
          return arr2[1];
        }
      }
    },
    clearCookie () {
      this.setCookie("", "", -1);  //清除cookie
    },
    login () {
      var _that = this;
      this.$refs["baseForm"].validate((valid) => {
        if (valid) {
          _that.disable = false;
          // try {
          //   let data = login();
          //   let token = data.token;
          //   this.$store.commit('LOGIN_IN', token);
          //   this.$router.replace('/');
          // } catch (e) {
          //   console.log(e);
          // }
          if (_that.formData.checked == true) {
            //存入cookie
            _that.setCookie(_that.formData.username, _that.formData.password, 7);  //保存7天
          } else {
            _that.clearCookie();
          }
          login({
            studentPhoneAndName: this.formData.username,
            password: this.formData.password
          }).then(res => {
            //console.log(res);
            if (res.data.code == "200") {
              let data = res.data.data;
              //console.log(data);
              _that.$store.commit('LOGIN_IN', data);
              // var stuNumber = JSON.parse(localStorage.getItem("studentsList"))[0].student_phonenumber;
              // if (localStorage.getItem("student_phonenumber") == stuNumber) {
              //   this.$router.replace("/curriculumAreas");
              // } else {
              //   localStorage.setItem("student_phonenumber", stuNumber);
              //   this.$router.replace("/detection");
              // }
              _that.$router.replace('/');
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // async login () {
    //   try {
    //     let data = await login();
    //     let token = data.token;
    //     this.$store.commit('LOGIN_IN', token);
    //     this.$router.replace('/');
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
.loginTop {
  img {
    width: 418px;
    height: auto;
  }
}
.loginDiv {
  width: 100%;
  height: 100vh;
  margin: 0px;
  background: url("../../../static/images/bg.png") no-repeat;
  background-size: 100% 100%;
}
.loginMain {
  width: 1062px;
  height: 523px;
  position: absolute;
  right: 50%;
  top: 50%;
  margin-right: -531px;
  margin-top: -262px;
  display: flex;
  padding-top: 63px;
  img {
    width: 622px;
    height: auto;
  }
}
.login {
  width: 400px;
  height: 440px;
  background: #ffffff;
  border-radius: 24px;
  border: 4px solid rgba(54, 121, 230, 1);
  position: relative;
  padding: 65px 34px;
  .dz {
    position: absolute;
    top: -90px;
    right: 0;
    width: 108px;
    height: auto;
  }
  .logoL {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    img {
      width: 174px;
      height: auto;
    }
  }
  .tip {
    color: #888;
    font-size: 12px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 28px;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 32px;
  }
  /deep/ .el-form-item--small .el-form-item__error {
    padding-top: 5px;
  }
  /deep/ .el-input__inner {
    width: 332px;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    color: #333;
    border: 1px solid #d9d9d9;
  }
  /deep/ .veCode .el-form-item__content {
    display: flex;
    .el-button {
      border-radius: 8px;
    }
  }
  /deep/ .veCode .el-input__inner {
    width: 218px;
  }
  /deep/ .formBtn .el-button {
    width: 332px;
    height: 40px;
    font-size: 14px;
    color: #333;
    background: #deedfc;
    border-radius: 20px;
    width: 100%;
  }
  /deep/ .formBtn .disable {
    background: linear-gradient(180deg, #26b1f2 0%, #09cbf9 100%);
    color: #fff;
  }
  /deep/ .el-form-item__label {
    color: #aaa;
    font-size: 14px;
    font-weight: 700;
  }
}
.register {
  line-height: 30px;
  display: flex;
  color: #fff;
  margin: 0;
  padding: 0;
}
/deep/ .el-form .el-form-item .el-form-item__error {
  top: 100%;
  margin-top: 3px;
}
.formBtn {
  margin-bottom: 0;
  margin-top: 40px;
  /deep/ .el-form-item__content {
    width: 100% !important;
  }
}
@keyframes beat {
  0% {
    margin-top: 0px;
  }

  100% {
    margin-top: 20px;
  }
}
.leftDx {
  margin-top: -30px;
}
.dx {
  margin-top: 20px;
  animation-name: beat;
  /*动画名称*/
  animation-duration: 1s;
  /*设置秒数*/
  animation-timing-function: linear;
  /*速度曲线*/
  animation-iteration-count: infinite;
  /*播放次数*/
  animation-direction: alternate;
  /*逆向播放*/
  animation-play-state: running;
  /*正在运行*/
}
</style>


// WEBPACK FOOTER //
// src/page/login/login.vue